import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import {
  AUTH_SESSION_VALIDATION_QUERY_KEY,
  isUnauthorizedError,
  notifyAuthSessionExpired,
} from "./auth-session";

function isSessionValidationQuery(queryKey: readonly unknown[]): boolean {
  return queryKey[0] === AUTH_SESSION_VALIDATION_QUERY_KEY;
}

export function shouldRetryAdminQuery(
  failureCount: number,
  error: unknown,
  maxRetries = 3,
): boolean {
  return !isUnauthorizedError(error) && failureCount < maxRetries;
}

export function createAdminQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError(error, query) {
        if (isUnauthorizedError(error) && !isSessionValidationQuery(query.queryKey)) {
          notifyAuthSessionExpired();
        }
      },
    }),
    mutationCache: new MutationCache({
      onError(error) {
        if (isUnauthorizedError(error)) notifyAuthSessionExpired();
      },
    }),
    defaultOptions: {
      queries: {
        retry(failureCount, error) {
          return shouldRetryAdminQuery(failureCount, error);
        },
      },
      mutations: { retry: false },
    },
  });
}
